import logo from '@/assets/hiredcoach-logo.svg';
import ContactContent from '@/components/ContactContent';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import Seo from '@/components/marketing/Seo';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

const Contact: React.FC = () => {
  const { user } = useAuth();

  const buildMailto = (
    local: string,
    domain: string,
    tld: string,
    subject: string,
  ) => {
    const address = [local, '@', domain, '.', tld].join('');
    const bodyPrefix = user?.id ? `User ID: ${user.id}\n\n` : '';
    const body = `${bodyPrefix}`;
    const uri = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return uri;
  };

  const handleSupportClick = () => {
    window.location.href = buildMailto('support', 'hiredcoach', 'ai', 'Support request');
  };

  const handleFounderClick = () => {
    window.location.href = buildMailto('keith', 'hiredcoach', 'ai', 'Message for the Founder');
  };

  const copyToClipboard = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success('Email copied to clipboard');
    } catch (e) {
      toast.error('Failed to copy email');
    }
  };

  const copySupportEmail = () => copyToClipboard(['support', '@', 'hiredcoach', '.', 'ai'].join(''));
  const copyFounderEmail = () => copyToClipboard(['keith', '@', 'hiredcoach', '.', 'ai'].join(''));

  if (user) {
    return (
      <DashboardLayout>
        <Seo
          title="Contact HiredCoach"
          description="Contact the HiredCoach team for product and support questions."
          canonicalPath="/contact"
        />
        <div className="max-w-4xl mx-auto">
          <ContactContent />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Contact HiredCoach"
        description="Contact the HiredCoach team for product and support questions."
        canonicalPath="/contact"
      />
      {/* Header branding to match landing */}
      <header className="bg-white shadow-sm sticky top-0 z-30">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <nav className="flex justify-between items-center">
            <Link to="/" className="flex items-center min-w-0 flex-shrink hover:opacity-90 transition-opacity">
              <img src={logo} alt="HiredCoach Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-1 sm:mr-2 flex-shrink-0" />
              <span className="font-bold text-lg sm:text-xl truncate">
                <span style={{ color: '#4f9ecb' }}>Hired</span><span style={{ color: '#334763' }}>Coach</span>
              </span>
            </Link>
            <div className="flex gap-2" />
          </nav>
        </div>
      </header>

      {/* Content */}
      <section className="bg-gray-50">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-3xl mx-auto">
            <Card className="bg-white border-gray-200 shadow-sm">
              <ContactContent />
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

